import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import clock from "../assets/images/clock.svg";
import schedule from "../assets/images/schedule.svg";

function SolarEstimationAr() {
  const location = useLocation();
  const navigate = useNavigate();
  const [simpleMethod, setSimpleMethod] = useState(false);
  const [detailedMethod, setDetailedMethod] = useState(false);
  const [rooms, setRooms] = useState("");
  const [people, setPeople] = useState("");
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [manager, setManager] = useState("");
  const [energy_manager, setEnergy_manager] = useState("");
  const [items, setItems] = useState([]);
  const [aaa, setAaa] = useState("");

  const [areaPicked, setAreaPicked] = useState("");
  const [mohafazaName, setMohafazaName] = useState("");
  const [casaName, setCasaName] = useState("");
  const [regionName, setRegionName] = useState("");
  const [kwh, setKwh] = useState("");
  const [usd, setUsd] = useState("");
  const [savings, setSavings] = useState("");

  useEffect(() => {
    if (location.state) {
      setKwh(location.state.kwh);
      setAaa(location.state.aaa);
      setUsd(location.state.usd);
      setSavings(location.state.savings);
      setAge(location.state.age);
      setPeople(location.state.people);
      setRooms(location.state.rooms);
      setGender(location.state.gender);
      setEnergy_manager(location.state.energy_manager);
      setManager(location.state.manager);
      setItems(location.state.items);
      setAreaPicked(location.state.areaPicked);
      setMohafazaName(location.state.mohafazaName);
      setCasaName(location.state.casaName);
      setRegionName(location.state.regionName);
    }
  }, [location.state]);

  return (
    <div dir="rtl">
      <div className="solar-estimation-page solar-estimation-page-ar mx-lg-auto">
        <p className="method-text font-arabic-regular">
          دعنا نساعدك في تقدير متطلبات نظام الطاقة الشمسية الخاص بك بناءً على
          استهلاكك المنزلي الحالي.
        </p>
        <p className="method-text font-arabic-regular">
          ما هي الطريقة التي تفضلها؟
        </p>
        <div
          className={`method-item ${simpleMethod && `picked`}`}
          onClick={(e) => {
            setSimpleMethod(true);
            navigate("/appliances-simplified-ar", {
              state: {
                age: age,
                people: people,
                rooms: rooms,
                gender: gender,
                energy_manager: energy_manager,
                manager: manager,
                items: items,
                areaPicked: areaPicked,
                mohafazaName: mohafazaName,
                casaName: casaName,
                regionName: regionName,
                kwh: kwh,
                usd: usd,
                aaa: aaa,
                savings: savings,
              },
            });
          }}
        >
          <img src={clock} alt="clock" />
          <div>
            <h4 className="font-arabic-regular">
              الاعتماد على القيام بمعدلات بسيطة
            </h4>
            <i className="font-arabic-regular"> ٢-٤ دقائق لإكمال</i>
          </div>
        </div>

        <div
          className={`method-item detailed-method ${detailedMethod &&
            `picked`}`}
          onClick={(e) => {
            setDetailedMethod(true);
            navigate("/appliances-ar", {
              state: {
                age: age,
                people: people,
                rooms: rooms,
                gender: gender,
                energy_manager: energy_manager,
                manager: manager,
                items: items,
                areaPicked: areaPicked,
                mohafazaName: mohafazaName,
                casaName: casaName,
                regionName: regionName,
                kwh: kwh,
                aaa: aaa,
                usd: usd,
                savings: savings,
              },
            });
          }}
        >
          <img src={schedule} alt="schedule" />
          <div>
            <h4 className="font-arabic-regular">
              مفصلة على أساس الأجهزة الدقيقة والاستخدام
            </h4>
            <i className="font-arabic-regular"> ١٢-١٥ دقائق لإكمال</i>
          </div>
        </div>

        <div className="d-flex padding-bottom justify-content-center">
          <div
            className={`active box`}
            onClick={() => {
              navigate("/feedback");
            }}
          ></div>
          <div className={`active box`}></div>
          <div className={`inactive box`}></div>
          <div className={`inactive box`}></div>
          <div className={`inactive box`}></div>
        </div>
      </div>
    </div>
  );
}

export default SolarEstimationAr;
